import Vue from 'vue'
import Router from 'vue-router'
import coreRoutes from './modules/core/routing'
import { EVENT_USER_LOGGED_IN, EVENT_USER_LOGGED_OUT } from './modules/core/stores/current-user'
import EventBus from './modules/core/bus'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: '/app/',
    routes: [],
})

// pridame routy z core ktere jsou vzdycky pritomne
router.addRoutes(coreRoutes)

EventBus.$on(EVENT_USER_LOGGED_IN, _ => router.push('/dashboard'))

EventBus.$on(EVENT_USER_LOGGED_OUT, _ => router.push('/'))

export default router
